import { createContext, useState } from 'react';
import { DEFAULT } from '../components/DreamspaceElements/variants';

const TailwindThemeContext = createContext<any>(null);
const TailwindThemeConsumer = TailwindThemeContext.Consumer;

type Theme = {
  tailwind: Record<string, any>;
  siteBackground: Record<string, any>;
};

const TailwindThemeProvider = (props: { children?: React.ReactNode }) => {
  const [variants, setVariants] = useState<any>(DEFAULT);
  const [theme, setTheme] = useState<Theme>({
    tailwind: {},
    siteBackground: {},
  });

  const setTailwind = (tailwind: Record<string, any>) => {
    setTheme((prev: Theme) => ({
      ...prev,
      tailwind,
    }));
  };

  const setSiteBackground = (siteBackground: Record<string, any>) => {
    setTheme((prev: Theme) => ({
      ...prev,
      siteBackground,
    }));
  };

  return (
    <TailwindThemeContext.Provider
      value={{
        variants,
        setVariants,
        theme,
        setTheme,
        tailwind: theme?.tailwind ?? {},
        setTailwind,
        siteBackground: theme?.siteBackground ?? {},
        setSiteBackground,
      }}
    >
      {props.children}
    </TailwindThemeContext.Provider>
  );
};

export { TailwindThemeContext, TailwindThemeConsumer, TailwindThemeProvider };
